<template>
	<div class="row">
		<div class="col-md-30">
			<h2 v-tr="'landingpage_scopeandsequence_big_description_heading'" class="mia-mainHeading" />
			<p class="mia-description">
				<span v-tr="'landingpage_scopeandsequence_big_description'" />
				<a v-tr="'landingpage_scopeandsequence_faq_link_text'" :href="accreditationFaqLink" />
			</p>
		</div>
		<scope-and-sequence-control class="col-md-30" :show-description="true" :scope-and-sequence-links="scopeAndSequenceLinks" />
	</div>
</template>
<script lang="ts">
import { MiaPlaza } from "@/Reinforced.Typings";
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";
import ScopeAndSequenceControl from "./ScopeAndSequenceControl.vue";

@Component({
	components: { ScopeAndSequenceControl },
})
export class ScopeAndSequencePanel extends Vue {
	@Prop({type: Object, required: true}) scopeAndSequenceLinks!: Record<MiaPlaza.Model.Subject, string>;
	@Prop({type: String, required: true}) accreditationFaqLink!: string;
}

export default toNative(ScopeAndSequencePanel);
</script>
<style lang="scss">
.mia-ScopeAndSequencePanel {
	.mia-heading {
		padding-bottom: theme.$mia-padding-panel;
		border-bottom: theme.$mia-border-width-panel-small theme.$mia-color-panel-separator solid;
	}

	.mia-description {
		padding-right: theme.$padding-large-horizontal;
	}

	@media(max-width: theme.$screen-xs-max) {
		.mia-heading, .mia-mainHeading {
			text-align: center;
		}

		.mia-description {
			padding-left: theme.$mia-padding-panel-large;
		}
	}
}
</style>
